import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import { getUrl } from 'Router/urlConfig';
import { useUserData } from 'Contexts/UserContext';
import { saveDataInLocalStorage, removeDataInLocalStorage } from 'dist/Storage/localStorageMethods';

function Blank() {
  const { token, instruction } = useParams();
  const { setUserData, setLoading } = useUserData();
  const history = useHistory();

  const apiURL = getUrl('api');
  const appUrl = getUrl('app');

  const loginPanel = async () => {
    const response = await axios.post(`${apiURL}/login/panel`, {}, {
      headers: {
        authorization: token,
        'Content-Type': 'application/json',
      },
    });

    return response;
  };

  useEffect(async () => {
    removeDataInLocalStorage('vacanted');
    removeDataInLocalStorage('firebase-info');
    await loginPanel()
      .then((response) => {
        if (response.status === 201) {
          setUserData({ loginStatus: true, data: response.data });
          saveDataInLocalStorage('vacanted', response.data);
          setLoading(false);
          if (instruction) {
            history.push(`/family/${instruction}${window.location.search || ''}`);
            return response;
          }
          history.push('/family/dashboard');
        }
        return response;
      }).catch(() => window.location.replace(`${appUrl}/auth/login`));

    return false;
  }, []);

  return (
    <div>
      {/* <h1>teste</h1> */}
    </div>
  );
}

export default Blank;
